import { createDateRangeFilterConfig } from '../factories/create-date-range-filter-config';
import { buildDateRangeFacetKey } from '../helpers/build-date-range-facet-key';
import { FILTER_COLOR } from './filter-colors';

export const leadNextFollowUpDateFilterConfig = createDateRangeFilterConfig({
  facetName: buildDateRangeFacetKey({
    before: 'next_follow_up_date_before',
    after: 'next_follow_up_date_after',
  }),
  color: FILTER_COLOR.yellow,
});
